import { Map } from 'immutable'
import { createSelector } from 'reselect'
import { root as endUserRoot } from '../selectors'

export const root = createSelector(endUserRoot, (endUserRoot) => endUserRoot.get('segments'))
export const segmentsByEndUserId = (state) => root(state).get('segmentsByEndUserId')

export const segmentFetchedForEndUser = (state, props) => segmentsByEndUserId(state).has(props.endUser.id)
export const endUserSegments = (state, props) => segmentsByEndUserId(state).get(props.endUser.id)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/endUser/segment/selectors.js